// store/modules/round.js
import {secureStorage} from "@/services/secureStorage";

const deferredStorageTimers = {};

function scheduleDeferredStorageWrite(key, value) {
    if (deferredStorageTimers[key]) {
        clearTimeout(deferredStorageTimers[key]);
    }

    deferredStorageTimers[key] = setTimeout(() => {
        delete deferredStorageTimers[key];

        const persist = () => {
            secureStorage.setItem(key, JSON.stringify(value));
        };

        if (typeof requestIdleCallback === 'function') {
            requestIdleCallback(persist);
            return;
        }

        setTimeout(persist, 0);
    }, 80);
}

function cancelDeferredStorageWrite(key) {
    if (!deferredStorageTimers[key]) {
        return;
    }

    clearTimeout(deferredStorageTimers[key]);
    delete deferredStorageTimers[key];
}

export default {
    namespaced: true,
    state: () => ({
        competitionRounds: JSON.parse(secureStorage.getItem('competitionRounds')) || [],
        competitionPodiums: JSON.parse(secureStorage.getItem('competitionPodiums')) || [],
        roundAthleteId: JSON.parse(secureStorage.getItem('roundAthleteId')) || null,
        roundIdToUpdate: JSON.parse(secureStorage.getItem('roundIdToUpdate')) || null,
        roundIdToView: JSON.parse(secureStorage.getItem('roundIdToView')) || null,
        roundCompetitionIdToCreate: JSON.parse(secureStorage.getItem('roundCompetitionIdToCreate')) || null,
        roundCompetitionIdToEdit: JSON.parse(secureStorage.getItem('roundCompetitionIdToEdit')) || null,
        roundCompetitionIdToView: JSON.parse(secureStorage.getItem('roundCompetitionIdToView')) || null,
    }),
    mutations: {
        setRounds(state, rounds) {
            state.competitionRounds = rounds;
            scheduleDeferredStorageWrite('competitionRounds', rounds);
        },
        setPodiums(state, podiums) {
            state.competitionPodiums = podiums;
            scheduleDeferredStorageWrite('competitionPodiums', podiums);
        },
        setRoundIdToUpdate(state, id) {
            state.roundIdToUpdate = id;
            secureStorage.setItem('roundIdToUpdate', id);
        },
        setRoundIdToView(state, id) {
            state.roundIdToView = id;
            secureStorage.setItem('roundIdToView', id);
        },
        setMutRoundCompetitionIdToCreate(state, id) {
            state.roundCompetitionIdToCreate = id;
            secureStorage.setItem('roundCompetitionIdToCreate', id);
        },
        setMutRoundCompetitionIdToEdit(state, id) {
            state.roundCompetitionIdToEdit = id;
            secureStorage.setItem('roundCompetitionIdToEdit', id);
        },
        setMutRoundCompetitionIdToView(state, id) {
            state.roundCompetitionIdToView = id;
            secureStorage.setItem('roundCompetitionIdToView', id);
        },
        setRoundAthleteIdMut(state, id) {
            state.roundAthleteId = id;
            secureStorage.setItem('roundAthleteId', id);
        },
        addOrUpdateRound(state, round) {
            const index = state.competitionRounds.findIndex(r => r.id === round.id);
            if (index !== -1) {
                // state.rounds.splice(index, 1, round); // actualiza
                // Vue necesita que se cambie la referencia
                state.competitionRounds[index] = { ...state.competitionRounds[index], ...round };
            } else {
                state.competitionRounds.push(round); // agrega nuevo
            }
            scheduleDeferredStorageWrite('competitionRounds', state.competitionRounds);
        },
        addOrUpdatePodium(state, podium) {
            const index = state.competitionPodiums.findIndex(r => r.id === podium.id);
            if (index !== -1) {
                // state.rounds.splice(index, 1, round); // actualiza
                // Vue necesita que se cambie la referencia
                state.competitionPodiums[index] = { ...state.competitionPodiums[index], ...podium };
            } else {
                state.competitionPodiums.push(podium); // agrega nuevo
            }
            scheduleDeferredStorageWrite('competitionPodiums', state.competitionPodiums);
        },
        resetCompetitionRounds(state) {
            cancelDeferredStorageWrite('competitionRounds');
            state.competitionRounds = [];
            secureStorage.removeItem('competitionRounds');
            secureStorage.removeItem('rounds');
        },
        resetCompetitionPodiums(state) {
            cancelDeferredStorageWrite('competitionPodiums');
            state.competitionPodiums = [];
            secureStorage.removeItem('competitionPodiums');
            secureStorage.removeItem('podiums');
        },
        resetRoundIdToUpdate(state) {
            state.roundIdToUpdate = null;
            secureStorage.removeItem('roundIdToUpdate');
        },
        resetRoundIdToView(state) {
            state.roundIdToView = null;
            secureStorage.removeItem('roundIdToView');
        },
        resetRoundCompetitionIdToCreate(state) {
            state.roundCompetitionIdToCreate = null;
            secureStorage.removeItem('roundCompetitionIdToCreate');
        },
        resetRoundCompetitionIdToEdit(state) {
            state.roundCompetitionIdToEdit = null;
            secureStorage.removeItem('roundCompetitionIdToEdit');
        },
        resetRoundCompetitionIdToView(state) {
            state.roundCompetitionIdToView = null;
            secureStorage.removeItem('roundCompetitionIdToView');
        },
        resetRoundAthleteId(state) {
            state.roundAthleteId = null;
            secureStorage.removeItem('roundAthleteId');
        },
        updateNegativeFeedbackCount(state, { round_id, count }) {
            const index = state.competitionRounds.findIndex(r => r.id === round_id);
            if (index !== -1) {
                state.competitionRounds[index] = {
                    ...state.competitionRounds[index],
                    negative_feedback_count: count,
                };
                scheduleDeferredStorageWrite('competitionRounds', state.competitionRounds);
            }
        }


    },
    actions: {
        setAllRounds(context, rounds) {
            context.commit('setRounds', rounds);
        },
        setAllPodiums(context, podiums) {
            context.commit('setPodiums', podiums);
        },
        setRoundAthleteId({ commit }, id) {
            commit('setRoundAthleteIdMut', id);
        },
        setRoundCompetitionIdToCreate(context, id) {
            context.commit('setMutRoundCompetitionIdToCreate', id);
        },
        setRoundCompetitionIdToEdit(context, id) {
            context.commit('setMutRoundCompetitionIdToEdit', id);
        },
        /*    setRoundCompetitionIdToCreate({ commit }, id) {
                commit('setMutRoundCompetitionIdToCreate', id);
            },*/
        setRoundCompetitionIdToView(context, id) {
            context.commit('setMutRoundCompetitionIdToView', id);
        },
        setCompetitionRoundIdToView(context, id) {
            context.commit('setMutRoundCompetitionIdToView', id);
        },
        upsertRound(context, rounds) {
            const normalize = (round) => {
                if (!round || typeof round !== 'object') return round;
                const normalized = { ...round };

                // CamelCase → snake_case for date fields
                if (round.publishAt && !round.publish_at) normalized.publish_at = round.publishAt;
                if (round.publishedAt && !round.published_at) normalized.published_at = round.publishedAt;
                if (round.uploadOpensAt && !round.upload_opens_at) normalized.upload_opens_at = round.uploadOpensAt;
                if (round.uploadOpenAt && !round.upload_open_at) normalized.upload_open_at = round.uploadOpenAt;
                if (round.uploadClosesAt && !round.upload_closes_at) normalized.upload_closes_at = round.uploadClosesAt;
                if (round.uploadCloseAt && !round.upload_close_at) normalized.upload_close_at = round.uploadCloseAt;
                if (round.opensAt && !round.opens_at) normalized.opens_at = round.opensAt;
                if (round.closesAt && !round.closes_at) normalized.closes_at = round.closesAt;

                // Verification code
                if (round.verificationCode && !round.verification_code) normalized.verification_code = round.verificationCode;

                // Stage calendar normalization
                if (round.stageCalendar && !round.stage_calendar) normalized.stage_calendar = round.stageCalendar;
                if (normalized.stage_calendar && normalized.stage_calendar.id && !normalized.stage_calendar_id) {
                    normalized.stage_calendar_id = normalized.stage_calendar.id;
                }

                // Normalize nested stage_calendar date fields for consistency (optional but helps downstream)
                if (normalized.stage_calendar && typeof normalized.stage_calendar === 'object') {
                    const sc = { ...normalized.stage_calendar };
                    if (sc.publishAt && !sc.publish_at) sc.publish_at = sc.publishAt;
                    if (sc.publishedAt && !sc.published_at) sc.published_at = sc.publishedAt;
                    if (sc.uploadOpensAt && !sc.upload_opens_at) sc.upload_opens_at = sc.uploadOpensAt;
                    if (sc.uploadOpenAt && !sc.upload_open_at) sc.upload_open_at = sc.uploadOpenAt;
                    if (sc.uploadClosesAt && !sc.upload_closes_at) sc.upload_closes_at = sc.uploadClosesAt;
                    if (sc.uploadCloseAt && !sc.upload_close_at) sc.upload_close_at = sc.uploadCloseAt;
                    if (sc.opensAt && !sc.opens_at) sc.opens_at = sc.opensAt;
                    if (sc.closesAt && !sc.closes_at) sc.closes_at = sc.closesAt;
                    normalized.stage_calendar = sc;
                }

                return normalized;
            };

            if (Array.isArray(rounds)) {
                rounds.forEach(round =>  context.commit('addOrUpdateRound', normalize(round)));
            } else {
                context.commit('addOrUpdateRound', normalize(rounds));
            }

        },
        upsertPodium(context, podiums) {
            if (Array.isArray(podiums)) {
                podiums.forEach(podium =>  context.commit('addOrUpdatePodium', podium));
            } else {
                context.commit('addOrUpdatePodium', podiums);
            }

        },
        clearRound({ commit }) {
            commit('resetCompetitionRounds');
        },
        clearPodium({ commit }) {
            commit('resetCompetitionPodiums');
        },
        clearRoundIdToUpdate({ commit }) {
            commit('resetRoundIdToUpdate');
        },
        clearRoundIdToView({ commit }) {
            commit('resetRoundIdToView');
        },
        clearCompetitionRoundIdToCreate(context) {
            context.commit('resetRoundCompetitionIdToCreate');
        },
        clearCompetitionRoundIdToEdit(context) {
            context.commit('resetRoundCompetitionIdToEdit');
        },
        clearCompetitionRoundIdToView(context) {
            context.commit('resetRoundCompetitionIdToView');
        },
        clearRoundAthleteId({ commit }) {
            commit('resetRoundAthleteId');
        },
        upsertNegativeFeedbackCount({ commit }, { round_id, count }) {
            commit('updateNegativeFeedbackCount', { round_id, count });
        }


    },
    getters: {
        getRounds: state => state.competitionRounds,
        getRoundById: (state) => (id) => {
            return state.competitionRounds.find(r => r.id === id);
        }
    }

};
